/**
 * Analytics helpers — GA4 + GTM events.
 *
 * Notes:
 * - `formStartFired` is a module-scoped flag, so a single form_start fires
 *   max once per SPA session regardless of which entry point triggers it first.
 *   It persists across client-side navigation between pages (e.g. / and /montaz)
 *   and resets only on full page reload.
 * - All helpers silently no-op when window.gtag is not loaded (e.g. ad-blockers).
 * - Every event automatically includes the current pathname.
 */

let formStartFired = false;

function safeGtag(event, params) {
  if (typeof window === "undefined") return;
  if (typeof window.gtag !== "function") return;
  try {
    window.gtag("event", event, params);
  } catch (_e) {
    // silently ignore
  }
}

function pathname() {
  if (typeof window === "undefined") return "/";
  return window.location.pathname || "/";
}

/** Fires form_start max once per session. */
export function trackFormStart(formLocation) {
  if (formStartFired) return;
  formStartFired = true;
  safeGtag("form_start", {
    form_location: formLocation,
    page: pathname(),
  });
}

export function trackGenerateLead(formLocation) {
  safeGtag("generate_lead", {
    form_location: formLocation,
    page: pathname(),
  });
}

export function trackEvent(name, params = {}) {
  safeGtag(name, { ...params, page: pathname() });
}
